import { useEffect } from "react";

export const SITE = "https://claridentrcm.com";
const DEFAULT_IMAGE = `${SITE}/logo.png`;

const upsertMeta = (keyAttr, keyVal, value) => {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${keyAttr}="${keyVal}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyAttr, keyVal);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

// Per-page SEO: unique title, description, canonical, Open Graph, Twitter,
// robots, and JSON-LD structured data (cleaned up on navigation to prevent
// duplicate/conflicting schema).
export default function useSeo({ title, description, path, image, robots = "index, follow", schemas = [] }) {
  useEffect(() => {
    if (title) document.title = title;
    const url = `${SITE}${path || window.location.pathname}`;
    const img = image || DEFAULT_IMAGE;

    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (title) {
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "ClariDent RCM");
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:image", img);
    upsertMeta("name", "robots", robots);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    document.querySelectorAll('script[data-seo-schema="true"]').forEach((n) => n.remove());
    const added = (schemas || []).filter(Boolean).map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-schema", "true");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => added.forEach((n) => n.remove());
  }, [title, description, path, image, robots, JSON.stringify(schemas)]);
}
